import { format, isValid, parseISO } from 'date-fns';
import { useEffect, useState } from 'react';
import Text from '../Text';
import InputContainerWrapper from './style/inputContainerWrapper';
import InputWrapper from './style/inputWrapper';
import LabelWrapper from './style/labelWrapper';

const DateInput = ({
  label,
  value,
  onChange,
  error,
  placeholder = 'DD-MM-YYYY',
  ...props
}) => {
  const [inputValue, setInputValue] = useState('');
  const [invalidMessage, setInvalidMessage] = useState('');

  useEffect(() => {
    if (value instanceof Date && isValid(value)) {
      setInputValue(format(value, 'dd-MM-yyyy'));
    }
  }, [value]);

  const handleChange = (e) => {
    let val = e.target.value;

    // Remove all characters except digits and dash
    val = val.replace(/[^\d-]/g, '');

    // Prevent input longer than 10 chars
    if (val.length > 10) return;

    // Auto-insert dashes only when typing forward
    if (val.length === 2 && inputValue.length < val.length) val = `${val}-`;
    if (val.length === 5 && inputValue.length < val.length) val = `${val}-`;

    setInputValue(val);
    setInvalidMessage(''); // clear previous messages

    // Validate when complete
    if (val.length === 10) {
      const [dd, mm, yyyy] = val.split('-');
      const day = parseInt(dd, 10);
      const month = parseInt(mm, 10);

      if (day < 1 || day > 31 || month < 1 || month > 12) {
        setInvalidMessage('Invalid day or month');
        onChange?.(null);

        return;
      }

      const isoString = `${yyyy}-${mm}-${dd}`;
      const parsedDate = parseISO(isoString);

      if (isValid(parsedDate)) {
        setInvalidMessage('');
        onChange?.(parsedDate);
      } else {
        setInvalidMessage('Invalid date');
        onChange?.(null);
      }
    } else {
      onChange?.(null); // incomplete input clears value
    }
  };

  const inputField = (
    <InputWrapper
      {...props}
      $styleType='date'
      type='text'
      value={inputValue}
      placeholder={placeholder}
      onChange={handleChange}
    />
  );

  const displayError = error || invalidMessage;

  if (label) {
    return (
      <LabelWrapper $preventLabelClick>
        {label && (
          <Text size='SM' className='label-text'>
            {label}
          </Text>
        )}
        {inputField}
        {displayError && (
          <Text size='SM' className='error-message'>
            {displayError}
          </Text>
        )}
      </LabelWrapper>
    );
  }

  return (
    <InputContainerWrapper $styleType='date'>
      {inputField}
      {displayError && (
        <Text size='SM' className='error-message'>
          {displayError}
        </Text>
      )}
    </InputContainerWrapper>
  );
};

export default DateInput;
